<template>
  <div class="ticketure-checkout__checkout-container">

    <div class="ticketure-checkout__header flex flex-wrap md:flex-no-wrap items-stretch mt-8 mb-16">
      <div class="flex-initial flex-shrink-0 w-24 mx-auto md:ml-0 md:mr-12 mb-8">
        <a :href="homeUrl" class="block">
          <img class="block" :src="logo" :alt="logoAlt">
        </a>
      </div>

      <div class="flex-initial w-full md:w-auto md:ml-auto flex-grow flex items-stretch">
        <div class="ticketure-checkout__header-section flex-initial w-1/3 border-b-2" :class="activeSection(1)">
          <span class="ticketure-checkout__header-section-number">1</span>
          <span class="ticketure-checkout__header-section-check"></span>
          <span class="block text-center text-sm font-medium mb-2">Checkout</span>
        </div>
        <div class="ticketure-checkout__header-section flex-initial w-1/3 border-b-2" :class="activeSection(2)">
          <span class="ticketure-checkout__header-section-number">2</span>
          <span class="ticketure-checkout__header-section-check"></span>
          <span class="block text-center text-sm font-medium mb-2">Billing Information</span>
        </div>
        <div class="ticketure-checkout__header-section flex-initial w-1/3 border-b-2" :class="activeSection(3)">
          <span class="ticketure-checkout__header-section-number">3</span>
          <span class="ticketure-checkout__header-section-check"></span>
          <span class="block text-center text-sm font-medium mb-2">Payment Method</span>
        </div>
      </div>
    </div>

    <div v-if="page === 1" class="ticketure-checkout__section">

      <template v-if="isGuestCheckout">

        <p class="mb-8">
          Are you a member? <button type="button" @click="isGuestCheckout = !isGuestCheckout" class="font-bold underline hover:no-underline">Login</button> | <button @click="toggleBuyMembership()" type="button" class="font-bold underline hover:no-underline">Become a Member</button>

          <button
            type="button"
            class="btn-white buy-membership-button hidden"
            id="buy-membership-button"
            data-toggle-class="is-open"
            data-toggle-target="#buy-membership, body"
            data-toggle-escape
            aria-controls="panel"
            aria-expanded="false">
            Buy Membership
          </button>
        </p>

        <p class="hdg-4 mb-8">Hi there, Checkout as a guest</p>

        <div class="ticketure-checkout__input" :class="{ 'has-error': emailAddressError }">
          <label for="checkout_email_address">Email Address</label>
          <p v-if="emailAddressError" class="text-sm mb-2 text-red-error">Please enter a valid email address.</p>
          <div class="relative">
            <input v-model="emailAddress" type="text" name="checkout_email_address" id="checkout_email_address" value="">
          </div>
          <p class="text-sm mt-4">This email will be only be used to email your purchase confirmation.</p>
        </div>

        <div class="flex mt-12">
          <button class="flex-initial ml-auto btn-tan" type="button" @click="continueToBilling()">Continue to Billing</button>
        </div>

      </template>

      <template v-else>

        <p class="mb-8"><button type="button" @click="isGuestCheckout = !isGuestCheckout" class="hover:underline flex items-center"><svg class="icon icon-left-arrow mr-1"><use xlink:href="#icon-left-arrow"></use></svg> Back to Guest Checkout</button></p>

        <p class="hdg-4 mb-8">Welcome back, USKC Member!</p>

        <div class="ticketure-checkout__input" :class="{ 'has-error': loginError }">
          <label for="checkout_membership_id_login">Membership ID</label>
          <p v-if="loginError" class="text-sm mb-2 text-red-error">Invalid Membership ID/Zip Code.</p>
          <div class="relative">
            <input v-model="membershipId" type="text" name="checkout_membership_id_login" id="checkout_membership_id_login" value="">
          </div>
        </div>

        <div class="ticketure-checkout__input" :class="{ 'has-error': loginError }">
          <label for="checkout_zip_code_login">Zip Code</label>
          <div class="relative">
            <input v-model="zipCode" type="text" name="checkout_zip_code_login" id="checkout_zip_code_login" value="">
          </div>
        </div>

        <div class="flex mt-12">
          <button class="flex-initial ml-auto btn-tan" type="button" @click="login()">Log In</button>
        </div>

      </template>

    </div>

    <div v-if="page === 2" class="ticketure-checkout__section">

      <p class="mb-8" v-if="! isLoggedIn"><button type="button" @click="page = 1" class="hover:underline flex items-center"><svg class="icon icon-left-arrow mr-1"><use xlink:href="#icon-left-arrow"></use></svg> Back</button></p>

      <p class="hdg-4 mb-8">Billing Information</p>

      <div class="ticketure-checkout__input" :class="{ 'has-error': firstNameError }">
        <label for="billing_first_name">First Name</label>
        <p v-if="firstNameError" class="text-sm mb-2 text-red-error">Please enter your first name.</p>
        <div class="relative">
          <input v-model="firstName" type="text" name="billing_first_name" id="billing_first_name" value="">
        </div>
      </div>

      <div class="ticketure-checkout__input" :class="{ 'has-error': lastNameError }">
        <label for="billing_last_name">Last Name</label>
        <p v-if="lastNameError" class="text-sm mb-2 text-red-error">Please enter your last name.</p>
        <div class="relative">
          <input v-model="lastName" type="text" name="billing_last_name" id="billing_last_name" value="">
        </div>
      </div>

      <div class="ticketure-checkout__input" :class="{ 'has-error': addressError }">
        <label for="billing_address">Address</label>
        <p v-if="addressError" class="text-sm mb-2 text-red-error">Please enter your street address.</p>
        <div class="relative">
          <input v-model="address" type="text" name="billing_address" id="billing_address" value="">
        </div>
      </div>

      <div class="row">
        <div class="col w-1/2">
          <div class="ticketure-checkout__input" :class="{ 'has-error': cityError }">
            <label for="billing_city">City</label>
            <p v-if="cityError" class="text-sm mb-2 text-red-error">Please enter your city.</p>
            <div class="relative">
              <input v-model="city" type="text" name="billing_city" id="billing_city" value="">
            </div>
          </div>
        </div>
        <div class="col w-1/2">
          <div class="ticketure-checkout__input" :class="{ 'has-error': stateError }">
            <label for="billing_state">State</label>
            <p v-if="stateError" class="text-sm mb-2 text-red-error">Please select your state.</p>
            <div class="relative">
              <select v-model="state" name="billing_state" id="billing_state">
                <option value="">Select a State</option>
                <option value="AL">Alabama</option>
              	<option value="AK">Alaska</option>
              	<option value="AZ">Arizona</option>
              	<option value="AR">Arkansas</option>
              	<option value="CA">California</option>
              	<option value="CO">Colorado</option>
              	<option value="CT">Connecticut</option>
              	<option value="DE">Delaware</option>
              	<option value="DC">District Of Columbia</option>
              	<option value="FL">Florida</option>
              	<option value="GA">Georgia</option>
              	<option value="HI">Hawaii</option>
              	<option value="ID">Idaho</option>
              	<option value="IL">Illinois</option>
              	<option value="IN">Indiana</option>
              	<option value="IA">Iowa</option>
              	<option value="KS">Kansas</option>
              	<option value="KY">Kentucky</option>
              	<option value="LA">Louisiana</option>
              	<option value="ME">Maine</option>
              	<option value="MD">Maryland</option>
              	<option value="MA">Massachusetts</option>
              	<option value="MI">Michigan</option>
              	<option value="MN">Minnesota</option>
              	<option value="MS">Mississippi</option>
              	<option value="MO">Missouri</option>
              	<option value="MT">Montana</option>
              	<option value="NE">Nebraska</option>
              	<option value="NV">Nevada</option>
              	<option value="NH">New Hampshire</option>
              	<option value="NJ">New Jersey</option>
              	<option value="NM">New Mexico</option>
              	<option value="NY">New York</option>
              	<option value="NC">North Carolina</option>
              	<option value="ND">North Dakota</option>
              	<option value="OH">Ohio</option>
              	<option value="OK">Oklahoma</option>
              	<option value="OR">Oregon</option>
              	<option value="PA">Pennsylvania</option>
              	<option value="RI">Rhode Island</option>
              	<option value="SC">South Carolina</option>
              	<option value="SD">South Dakota</option>
              	<option value="TN">Tennessee</option>
              	<option value="TX">Texas</option>
              	<option value="UT">Utah</option>
              	<option value="VT">Vermont</option>
              	<option value="VA">Virginia</option>
              	<option value="WA">Washington</option>
              	<option value="WV">West Virginia</option>
              	<option value="WI">Wisconsin</option>
              	<option value="WY">Wyoming</option>
              </select>
              <svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col w-1/3">
          <div class="ticketure-checkout__input" :class="{ 'has-error': zipCodeError }">
            <label for="billing_zip_code">Zip Code</label>
            <p v-if="zipCodeError" class="text-sm mb-2 text-red-error">Please enter your zip code.</p>
            <div class="relative">
              <input v-model="zipCode" type="text" name="billing_zip_code" id="billing_zip_code" value="">
            </div>
          </div>
        </div>

        <div class="col w-2/3">
          <div class="ticketure-checkout__input" :class="{ 'has-error': countryError }">
            <label for="billing_country">Country</label>
            <p v-if="countryError" class="text-sm mb-2 text-red-error">Please select your country.</p>
            <div class="relative">
              <select v-model="country" name="billing_country" id="billing_country">
                <option value="us">United States</option>
              </select>
              <svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg>
            </div>
          </div>
        </div>
      </div>

      <div class="ticketure-checkout__input" :class="{ 'has-error': phoneError }">
        <label for="billing_phone">Phone (optional)</label>
        <p v-if="phoneError" class="text-sm mb-2 text-red-error">Please enter your phone number.</p>
        <div class="relative">
          <input v-model="phone" type="text" name="billing_phone" id="billing_phone" value="">
        </div>
      </div>

      <div class="flex mt-12">
        <button class="flex-initial ml-auto btn-tan" type="button" @click="continueToPayment()">Continue to Payment</button>
      </div>

    </div>


    <div v-if="page === 3" class="ticketure-checkout__section">

      <p v-if="! isLoggedIn" class="mb-8"><button type="button" @click="page = 2" class="hover:underline flex items-center"><svg class="icon icon-left-arrow mr-1"><use xlink:href="#icon-left-arrow"></use></svg> Back</button></p>

      <template v-if="needsPayment">

        <p class="hdg-4 mb-8">Payment Method</p>

        <div class="ticketure-checkout__input">
          <label>Card Number</label>
          <div class="relative bg-gray-light-gray px-4 pt-6 rounded mb-8">
            <stripe-element-card
              ref="elementRef"
              :pk="pulishableKey"
              :stripeAccount="accountNumber"
              @token="tokenCreated"
              :elementStyle="style"
            />
          </div>
        </div>

        <p class="hdg-4 mb-8">Apply a Gift Card</p>

        <div class="ticketure-checkout__input" :class="{ 'has-error': giftCardError }">

          <div class="flex items-end">
            <div class="flex-initial flex-grow">
              <label for="payment_gift_card">Card Number</label>
              <p v-if="giftCardError" class="text-sm mb-2 text-red-error">{{ giftCardError }}</p>
              <div class="relative">
                <input v-model="giftCard" type="text" name="payment_gift_card" id="payment_gift_card" value="">
              </div>
            </div>

            <div class="flex-initial flex-shrink-0 ml-4">
              <button @click="applyGiftCard()" class="ticketure-checkout__apply-code ticketure-checkout__apply-code--apply" type="button">Apply</button>
              <button @click="removeGiftCard()" class="ticketure-checkout__apply-code ticketure-checkout__apply-code--remove hidden" type="button">Remove</button>
            </div>
          </div>

          <p v-if="giftCardValue" class="text-sm mb-2 text-green font-medium">Gift Card Balance: ${{ giftCardValue }}</p>

        </div>

      </template>

      <p class="hdg-4 mb-8 mt-8">Terms &amp; Conditions</p>

      <div class="ticketure-checkout__checkbox" :class="{ 'has-error': agreementError }">
        <p v-if="agreementError" class="text-sm mb-2 text-red-error">Please accept the Terms &amp; Conditions.</p>
        <input v-model="agreement" type="checkbox" name="payment_agreement" id="payment_agreement">
        <label for="payment_agreement">Please read and accept the Union Station <a :href="termsAndConditions" class="text-brand-primary underline hover:no-underline">Terms &amp; Conditions</a> to proceed with your order.</label>
      </div>

      <p v-if="orderError" class="text-lg mb-2 text-red-error">There has been an error with your payment details, or your cart may have expired.</p>

      <div class="flex mt-12">
        <button class="flex-initial ml-auto btn-tan" type="button" @click="submitPayment()">Complete Order</button>
      </div>

    </div>

    <div v-if="page === 4" class="ticketure-checkout__section">

      <p class="hdg-4 mb-8">Thank you for your purchase!</p>

      <p v-if="order" class="font-medium text-sm mb-10">Order Number: {{ order.ticket_order._data[0].order_number }}</p>

      <p>
        <a :href="homeUrl" class="btn-tan">Return Home</a>
      </p>

    </div>

  </div>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';
export default {
  components: {
    StripeElementCard,
  },
  props: [ 'logo', 'logoAlt', 'termsAndConditions', 'homeUrl' ],
  data() {
    this.pulishableKey = site_info.stripe_public_key;
    this.accountNumber = site_info.stripe_account_number;
    return {
      page: 1,
      token: null,
      isRunning: false,
      isGuestCheckout: true,
      emailAddress: '',
      emailAddressError: false,
      membershipId: '',
      zipCode: '',
      loginError: false,
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      state: '',
      country: 'us',
      phone: '',
      firstNameError: false,
      lastNameError: false,
      addressError: false,
      cityError: false,
      stateError: false,
      zipCodeError: false,
      countryError: false,
      phoneError: false,
      giftCard: '',
      giftCardError: false,
      giftCardValue: false,
      agreement: false,
      agreementError: false,
      order: false,
      orderError: false,
      needsPayment: true,
      style: {
        base: {
          iconColor: '#54565A',
          color: '#54565A',
          fontWeight: '500',
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          ':-webkit-autofill': {
            color: '#fce883',
          },
          '::placeholder': {
            color: '#54565A',
          },
          '::selection': {
            backgroundColor: '#F3F3F3',
          },
        },
        invalid: {
          iconColor: 'red',
          color: 'red',
        },
      },
    };
  },
  mounted() {
    const _this = this;
    _this.checkNeedsPayment();

    _this.giftCard = localStorage.getItem( 'giftCard' );
    _this.giftCardValue = localStorage.getItem( 'giftCardValue' );
  },
  methods: {
    checkNeedsPayment: function() {
      const _this = this;

      $.post(
        site_info.ajax_url,
        {
          action: 'll_run_function',
          function: 'check_needs_payment',
          params: {
            run: true,
          }
        },
        function(data, textStatus, xhr) {
          data = $.parseJSON( data );
          if ( data.status === 'success' ) {
            _this.needsPayment = data.response;

            if ( localStorage.getItem( 'totalOutstanding' ) === '0.00' ) {
              _this.needsPayment = false;
            }
          }
        }
      );
    },
    submitPayment: function() {
      const _this = this;
      // this will trigger the process
      if ( _this.needsPayment ) {
        this.$refs.elementRef.submit();
      } else {
        let isValidated = true;
        _this.agreementError = false;

        if ( ! _this.agreement ) {
          isValidated = false;
          _this.agreementError = true;
        }

        // Take the token created by Stripe Elements and pass it to Ticketure
        if ( ! _this.isRunning && isValidated ) {
          _this.isRunning = true;
          _this.orderError = false;

          // console.log( _this.giftCard );
          // console.log( _this.giftCardValue );

          $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'complete_checkout',
              params: {
                token: false,
                user_data: {
                  first_name: _this.firstName,
                  last_name: _this.lastName,
                  email: _this.emailAddress,
                  additional_info: {
                    address: _this.address,
                    city: _this.city,
                    state: _this.state,
                    country: _this.country,
                    zip_code: _this.zipCode,
                    phone: _this.phone,
                  }
                },
                gift_card_data: {
                  gift_card: _this.giftCard,
                  gift_card_value: _this.giftCardValue,
                }
              }
            },
            function(data, textStatus, xhr) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                // console.log( data.response );
                _this.order = data.response;
                _this.isRunning = false;

                if ( _this.order ) {
                  _this.page = 4;
                } else {
                  // Display errors
                  _this.orderError = true;
                }
              }
            }
          );
        }
      }
    },
    tokenCreated: function( token ) {
      const _this = this;
      let isValidated = true;
      _this.agreementError = false;

      if ( ! _this.agreement ) {
        isValidated = false;
        _this.agreementError = true;
      }

      // Take the token created by Stripe Elements and pass it to Ticketure
      if ( ! _this.isRunning && isValidated ) {
        _this.isRunning = true;
        _this.orderError = false;

        $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'complete_checkout',
            params: {
              token: token.id,
              user_data: {
                first_name: _this.firstName,
                last_name: _this.lastName,
                email: _this.emailAddress,
                additional_info: {
                  address: _this.address,
                  city: _this.city,
                  state: _this.state,
                  country: _this.country,
                  zip_code: _this.zipCode,
                  phone: _this.phone,
                }
              },
              gift_card_data: {
                gift_card: _this.giftCard,
                gift_card_value: _this.giftCardValue,
              }
            }
          },
          function(data, textStatus, xhr) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              _this.order = data.response;
              _this.isRunning = false;

              if ( _this.order ) {
                _this.page = 4;
              } else {
                // Display errors
                _this.orderError = true;
              }
            }
          }
        );
      }
    },
    continueToBilling: function() {
      const _this = this;
      _this.emailAddressError = false;

      if ( _this.validateEmail() ) {
        _this.page = 2;
      } else {
        _this.emailAddressError = true;
      }
    },
    continueToPayment: function() {
      const _this = this;
      let isValidated = true;

      _this.firstNameError = false;
      _this.lastNameError = false;
      _this.addressError = false;
      _this.cityError = false;
      _this.stateError = false;
      _this.zipCodeError = false;
      _this.countryError = false;
      _this.phoneError = false;

      if ( _this.firstName === '' ) {
        _this.firstNameError = true;
        isValidated = false;
      }

      if ( _this.lastName === '' ) {
        _this.lastNameError = true;
        isValidated = false;
      }

      if ( _this.address === '' ) {
        _this.addressError = true;
        isValidated = false;
      }

      if ( _this.city === '' ) {
        _this.cityError = true;
        isValidated = false;
      }

      if ( _this.state === '' ) {
        _this.stateError = true;
        isValidated = false;
      }

      if ( _this.zipCode === '' ) {
        _this.zipCodeError = true;
        isValidated = false;
      }

      if ( _this.country === '' ) {
        _this.countryError = true;
        isValidated = false;
      }

      if ( isValidated ) {
        _this.page = 3;
      }
    },
    login: function() {
      const _this = this;
      _this.loginError = false;

      if ( ! _this.isRunning ) {
        _this.isRunning = true;
        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'login_to_ticketure',
              params: {
                member_number: _this.membershipId,
                zip_code: _this.zipCode,
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                _this.isRunning = false;

                if ( data.response ) {
                  _this.$store.commit( 'setLoginState', true );
                  _this.page = 2;
                } else {
                  _this.loginError = true;
                }
              }
            }
        );
      }
    },
    applyGiftCard: function() {
      const _this = this;
      $( '#payment_gift_card' ).prop( 'disabled', true );
      _this.giftCardError = false;
      _this.giftCardValue = false;
      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'apply_gift_card',
            params: {
              code: _this.giftCard,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            // console.log( data.response );
            if ( data.status === 'success' ) {
              if ( ! data.response || data.response._status === 'error' ) {
                $( '#payment_gift_card' ).prop( 'disabled', false );
                if ( data.response._data[0]._description ) {
                  _this.giftCardError = data.response._data[0]._description;
                } else {
                  _this.giftCardError = 'Invalid gift card number.';
                }
              } else {
                if ( parseFloat( data.response.ledger._data[0].balance ) > 0 ) {
                  // Gift card is validated
                  // _this.payWithGiftCard( data.response.ledger._data[0].number, data.response.ledger._data[0].balance );
                  $( '.ticketure-checkout__apply-code--remove' ).removeClass( 'hidden' );
                  $( '.ticketure-checkout__apply-code--apply' ).addClass( 'hidden' );
                  _this.giftCardValue = data.response.ledger._data[0].balance;
                  localStorage.setItem( 'giftCardValue', _this.giftCardValue );
                  localStorage.setItem( 'giftCard', _this.giftCard );
                  app.components['cart'].loadCart();

                  setTimeout(function(){
                    _this.checkNeedsPayment();
                  }, 1000);
                } else {
                  _this.giftCardError = 'Gift card balance is $0.';
                }
              }
            }
          }
      );
    },
    removeGiftCard: function() {
      const _this = this;
      $( '#payment_gift_card' ).prop( 'disabled', false );
      localStorage.removeItem( 'giftCardValue', _this.giftCardValue );
      localStorage.removeItem( 'giftCard', _this.giftCard );
      _this.giftCard = '';
      $( '.ticketure-checkout__apply-code--remove' ).addClass( 'hidden' );
      $( '.ticketure-checkout__apply-code--apply' ).removeClass( 'hidden' );
    },
    payWithGiftCard: function( ledger, balance ) {
      const _this = this;
      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'pay_with_gift_card',
            params: {
              ledger: ledger,
              balance: balance,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              // app.components['cart'].loadCart();
              // _this.checkNeedsPayment();
            }
          }
      );
    },
    activeSection: function( page ) {
      const _this = this;
      if ( page === _this.page ) {
        return {
          'is-active': true,
        }
      } else if ( page < _this.page ) {
        return {
          'is-complete': true,
        }
      } else {
        return {
          'is-incomplete': true,
        }
      }
    },
    validateEmail: function() {
      const _this = this;
      const re = /^[^\s@]+@[^\s@]+$/;
      return re.test( _this.emailAddress );
    },
    toggleBuyMembership: function() {
      $( '.buy-membership-button' ).first().click();
    }
  },
  watch: {
    isLoggedIn: function( newValue, oldValue ) {
      if ( newValue ) {
        this.page = 3;
      }
    }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.state.isLoggedIn;
    }
  },
};
</script>
